module.exports = __webpack_public_path__ + "static/media/message-sent.833a7c94.svg";